module.exports = __webpack_public_path__ + "static/media/noData.488cc5a7.svg";